import { Descriptions } from 'antd';
import { CodeBlock, github } from 'react-code-blocks';
import type { DefaultTheme } from 'styled-components';

import { RequestInnerRequestInterface } from '@interface/logs/logs.interface';

interface RequestInfoProps {
  request: RequestInnerRequestInterface;
}

const codeBlockStyle = {
  backgroundColor: 'transparent',
  maxHeight: '500px',
  overflowY: 'auto',
};

export const RequestInfo = ({ request }: RequestInfoProps) => (
  <Descriptions size='small' title='Request' bordered>
    <Descriptions.Item label='Method' labelStyle={{ width: 120 }} span={2}>
      {request.method.toUpperCase()}
    </Descriptions.Item>
    <Descriptions.Item label='URL' labelStyle={{ width: 120 }} span={2}>
      {request.url}
    </Descriptions.Item>
    <Descriptions.Item label='Query' span={3}>
      <CodeBlock
        customStyle={codeBlockStyle}
        language='json'
        showLineNumbers={false}
        text={JSON.stringify(JSON.parse(request.query ?? '{}'), null, 4)}
        theme={github as unknown as DefaultTheme}
      />
    </Descriptions.Item>
    <Descriptions.Item label='Headers' span={3}>
      <CodeBlock
        customStyle={codeBlockStyle}
        language='json'
        showLineNumbers={false}
        text={JSON.stringify(JSON.parse(request.headers ?? '{}'), null, 4)}
        theme={github as unknown as DefaultTheme}
      />
    </Descriptions.Item>
    <Descriptions.Item label='Body' span={3}>
      <CodeBlock
        customStyle={codeBlockStyle}
        language='json'
        showLineNumbers={false}
        text={JSON.stringify(JSON.parse(request.body ?? '{}'), null, 4)}
        theme={github as unknown as DefaultTheme}
      />
    </Descriptions.Item>
  </Descriptions>
);
